import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";

const PUBLIC_API_PATHS = ["/api/login_check", "/api/forgot_password", "/api/reset_password"];
const PUBLIC_PAGES = ["/login", "/forgot-password", "/reset-password"];

export const api = axios.create({ baseURL: BASE_URL });

api.interceptors.request.use((config) => {
  const isPublic = PUBLIC_API_PATHS.some((path) => String(config.url || "").includes(path));
  if (!isPublic) {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      try { localStorage.removeItem("auth_token"); } catch {}
      const onPublicPage = typeof window !== "undefined"
        && PUBLIC_PAGES.some((path) => window.location.pathname.startsWith(path));
      if (typeof window !== "undefined" && !onPublicPage) {
        window.location.replace("/login");
      }
    }
    return Promise.reject(err);
  }
);

export default api; 